import React, { Component } from 'react';

export const isValidJahrgang = (jahrgang) => {
    return !isNaN(jahrgang) && Number(jahrgang) > 1900 && Number(jahrgang) < 2020;
}

export const valueIsNotEmpty = (value) => {
    return value.trim().length > 0;
}

export const valueIsNotEmptyAndLength = (value) => {
    return valueIsNotEmpty(value) && value.length < 40;
}

export const isValidEMail = (value) => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(value).toLowerCase());
}

export const validateData = (data) => {
    let areAllValid = true;
    
    for (const fieldName in data) {
        let field = data[fieldName];

        if (field.validator) {
            let isFieldValid = field.validator(field.value);
            if (!isFieldValid) {
                areAllValid = false;
            }
        }
    }

    return areAllValid;
}


export class ValidatableInput extends Component {
    render() {
        const field = this.props.field;
        let isValid = field.validator ? field.validator(field.value) : true;

        const type = this.props.type ? this.props.type : "text";

        let style = "form-control"
        if (this.props.showValidationResult) {
            style += isValid ? " is-valid " : " is-invalid";
        }

        return (
            <React.Fragment>
                <input type={type} className={style} id={this.props.name} placeholder="" value={field.value} onChange={this.props.changeListener} />
                {field.invalidText && (<div className="invalid-feedback">{field.invalidText}</div>)}
            </React.Fragment>
        );
    }
}

export class ValidatableSelect extends Component {
   
    render() {
        const field = this.props.field;
        let isValid = field.validator ? field.validator(field.value) : true;

        let style = "form-control"
        if (this.props.showValidationResult) {
            style += isValid ? " is-valid " : " is-invalid";
        }

        //const options = this.props.options ? [{ id: -1, bezeichnung: ""}, ...this.props.options] : [];
        const options = field.value === "" ? [{ id: -1, bezeichnung: ""}, ...this.props.options] : (this.props.options || []);

        return (
            <React.Fragment>
                <select className={style} id={this.props.name} value={field.value} onChange={this.props.changeListener} >
                    {options.map((o, idx) => (<option key={idx} value={o.id}>{o.bezeichnung}</option>))}
                </select>
                {field.invalidText && (<div className="invalid-feedback">{field.invalidText}</div>)}
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Validation.js